import { useEffect, useRef, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { getCompanyAddress } from '@helpers/companies';

const Questions = ({ locationSurveyId, location, wording, selectedPage, languages }) => {
    const iframeRef = useRef(null);
    const { watch } = useFormContext();

    const questions = watch('questions');

    const filteredQuestions = useMemo(() => {
        if (selectedPage === null || selectedPage === undefined) return questions;
        const result = {};
        let newIndex = 0;
        Object.entries(questions).forEach(([, langs]) => {
            const page = langs[0]?.page || 0;
            if (page === selectedPage) {
                result[newIndex] = langs;
                newIndex++;
            }
        });
        return result;
    }, [questions, selectedPage]);

    useEffect(() => {
        const controller = new AbortController();
        const data = {
            locationName: location.locationName,
            businessAddress: getCompanyAddress(location.addressLine1, location.city),
            hasBusinessAddress: location.hasBusinessAddress,
            questions: filteredQuestions,
            languages,
            ...wording,
        };
        const sendUpdatedData = event => {
            if (event.origin === import.meta.env.REACT_APP_SURVEY_DOMAIN) {
                const message = event.data;
                if (message.type === 'pl-preview-iframe-loaded') {
                    iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-questions', data }, '*');
                }
            }
        };
        iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-questions', data }, '*');
        window.addEventListener('message', sendUpdatedData, { signal: controller.signal });
        return () => controller.abort();
    }, [location, filteredQuestions, languages, wording]);

    return (
        <iframe
            ref={iframeRef}
            allow="autoplay"
            width="100%"
            height="100%"
            src={`${import.meta.env.REACT_APP_SURVEY_DOMAIN}/preview/questions/${locationSurveyId}`}
            frameBorder="0"
        ></iframe>
    );
};

export default Questions;
